// extracted by mini-css-extract-plugin
export default {"loaderContainer":"LoadingOverlay_loaderContainer__SZq0A","loader":"LoadingOverlay_loader__6KgV0","loaderText":"LoadingOverlay_loaderText__o+Iaf"};